import imgEmptyNoData from 'assets/images/img_emptyview_no_data.png';
import AgencyHelper from 'features/Agency/agencyHelper';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import EmptyView from 'general/components/Others/EmptyView';
import MenuActionDropdown from 'general/components/Others/MenuActionDropdown';
import VITableRowDropDown from 'general/components/VITableRowDropDown';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useRouter from 'hooks/useRouter';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

AgencyReconciliationListView.propTypes = {
  agencyId: PropTypes.string,
  showFullUI: PropTypes.bool,
  initialRole: PropTypes.string,
};

AgencyReconciliationListView.defaultProps = {
  showFullUI: false,
  initialRole: '',
};

function AgencyReconciliationListView(props) {
  // MARK: ---- PROPERTIES ----
  const { agencyId, showFullUI, initialRole } = props;
  const router = useRouter();
  const { user } = useSelector((state) => state.auth);
  const isAdmin = user?.role === 'ADMIN' || user?.role === 'OPERATOR';
  const isAgency = user?.role === 'AGENCY';
  const [reconciliationList, setReconciliationList] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({
    q: '',
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    forRole: initialRole,
    status: '',
    month: '',
  });
  useEffect(() => {
    setLoading(true);
    // Lay danh sach doi soat cua agency
    let paramGetReconciliationList = { ...filter };
    if (agencyId) {
      paramGetReconciliationList.agencyId = agencyId;
    }
    paramGetReconciliationList = _.omitBy(paramGetReconciliationList, _.isEmpty);
    AgencyHelper.API.requestGetReconciliationList(paramGetReconciliationList)
      .then((data) => {
        if (data) {
          setReconciliationList(data);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [agencyId, filter]);
  const fullColumns = useMemo(() => {
    return [
      {
        id: 'RECONCILIATION_ID',
        name: (
          <span
            className="letter-spacing-unset"
            style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
          >
            Mã đối soát
          </span>
        ),
        selector: (row) => row?.reconciliationCode ?? row?.reconciliationId,
        width: '140px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'MONTH',
        name: (
          <span
            className="letter-spacing-unset"
            style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
          >
            Tháng đối soát
          </span>
        ),
        selector: (row) => Utils.formatDateTimeToString(row?.month, 'MM/yyyy'),
        width: '140px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'RECONCILIATION_TYPE',
        name: (
          <span
            className="letter-spacing-unset"
            style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
          >
            Loại đối soát
          </span>
        ),
        selector: (row) => row?.forRole,
        width: '120px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'AGENCY',
        name: (
          <span
            className="letter-spacing-unset"
            style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
          >
            Đối tác
          </span>
        ),
        selector: (row) => (
          <span
            className="cursor-pointer hover-opacity-60"
            onClick={() => {
              AgencyHelper.Navigation.navigateToAgencyDetail(null, row?.agency);
            }}
          >
            {row?.agency?.name}
          </span>
        ),
        minWidth: '240px',
        style: tableStyle.columns.link,
      },
      {
        id: 'DOCUMENT',
        name: (
          <span
            className="letter-spacing-unset"
            style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
          >
            Tài liệu đối soát
          </span>
        ),
        selector: (row) => {
          return row?.document ? (
            <span
              className="cursor-pointer hover-opacity-60"
              onClick={() => {
                Utils.openInNewTab(row?.document);
              }}
            >
              Xem chi tiết
            </span>
          ) : (
            <></>
          );
        },
        minWidth: '160px',
        style: tableStyle.columns.link,
      },
      // {
      //   id: 'METADATA',
      //   name: (
      //     <span
      //       className="letter-spacing-unset"
      //       style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
      //     >
      //       Metadata
      //     </span>
      //   ),
      //   selector: (row) => {
      //     return (
      //       <span className="cursor-pointer hover-opacity-60" onClick={() => {}}>
      //         Xem chi tiết
      //       </span>
      //     );
      //   },
      //   minWidth: '160px',
      //   style: tableStyle.columns.link,
      // },
      {
        name: (
          <span
            className="letter-spacing-unset"
            style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
          >
            Trạng thái đối soát
          </span>
        ),
        selector: (row) => (
          <KTLabel
            text={AgencyHelper.Utils.getReconciliationStatusName(row?.status)}
            isInline={true}
            size={KTLabelSize.medium}
            additionalClassName={`label-light-${AgencyHelper.Utils.getReconciliationStatusColor(
              row?.status
            )}`}
          />
        ),
        minWidth: '160px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'AMOUNT',
        name: (
          <div className="d-flex flex-column align-items-end">
            <span
              className="letter-spacing-unset"
              style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
            >
              Số tiền hoa hồng
            </span>
            <span
              className="letter-spacing-unset"
              style={UIHelper.buildFontStyle('500', '12px', AppColors.gray[700])}
            >
              VNĐ
            </span>
          </div>
        ),
        selector: (row) => <span>{Utils.formatNumber(row?.amount)}</span>,
        width: '160px',
        style: tableStyle.columns.normal,
        right: true,
      },
      {
        id: 'TIME',
        name: (
          <span
            className="letter-spacing-unset"
            style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
          >
            Ngày tạo
          </span>
        ),
        selector: (row) => (
          <span>{Utils.formatDateTimeToString(row?.createdAt, 'DD/MM/YYYY')}</span>
        ),
        width: '120px',
        style: tableStyle.columns.normal,
      },
      {
        name: (
          <span
            className="letter-spacing-unset"
            style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
          >
            Thao tác
          </span>
        ),
        width: '130px',
        style: {
          position: 'sticky',
          right: 0,
          backgroundColor: '#fff',
          borderLeft: '1px solid #ebedfe',
        },
        cell: (row) => {
          const actions = buildMoreActions(row);

          const menuItems = [
            {
              iconElement: (
                <i
                  className="fa-regular fa-eye"
                  style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                />
              ),
              text: "Xem chi tiết",
              click: () => {
                router.navigate(`${row?.reconciliationId}`);
              },
              show: true,
            },
            ...(actions && !_.isEmpty(actions)
              ? actions.map(action => ({
                iconElement: action.iconElement,
                text: action.text,
                click: () => action.click(),
                show: true,
              }))
              : [])
          ];

          return (
            <MenuActionDropdown
              menuAction={menuItems}
            />
          );
        },
      }
    ];
  }, [user, isAdmin]);

  // MARK: ---- METHODS ----
  const buildMoreActions = (reconciliationDetail) => {
    const actions = [];
    actions.push({
      text: 'Ký đối soát',
      iconElement: <i className="fa-regular fa-file-signature" style={{ color: AppColors.gray[700], fontSize: '1.1rem' }} />,
      click: () => { },
    });
    if (isAdmin) {
      if (AgencyHelper.Utils.checkReconciliationCanEdit(reconciliationDetail?.status)) {
        actions.push({
          text: 'Chỉnh sửa đối soát',
          iconElement: <i className="fa-regular fa-edit" style={{ color: AppColors.gray[700], fontSize: '1.1rem' }} />,
          click: () => { },
        });
      }
      if (AgencyHelper.Utils.checkReconciliationCanDelete(reconciliationDetail?.status)) {
        actions.push({
          text: 'Xoá đối soát',
          iconElement: <i className="fa-regular fa-trash-can" style={{ color: AppColors.gray[700], fontSize: '1.1rem' }} />,
          click: () => {
            AgencyHelper.UI.showDialogConfirmDeleteReconciliation(reconciliationDetail, () => {
              setFilter({ ...filter, page: 0 });
            });
          },
        });
      }
    }
    return actions;
  };

  return (
    <div className="px-4 pb-4 mt-4">
      {UIHelper.buildCard(
        <div>
          {/* header */}
          {showFullUI && (
            <div className="px-5 pt-5 d-flex justify-content-between align-items-center">
              {/* title */}
              <div className="d-flex flex-column align-items-start">
                <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                  Danh sách đối soát
                </span>
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  Tổng số:{' '}
                  <span style={{ color: AppColors.primary }}>
                    {Utils.formatNumber(reconciliationList?.length)} đối soát
                  </span>
                </span>
              </div>

              {/* actions */}
              {/* {isAdmin || isSale ? (
                UIHelper.buildGreenButton(
                  'Tạo đơn hàng',
                  () => {
                    router.navigate(AppRoute.agencySaleAddOrder);
                  },
                  <i className="fa-regular fa-circle-plus" />
                )
              ) : (
                <></>
              )} */}
            </div>
          )}

          {/* body */}
          <div className={`${showFullUI ? 'p-5' : 'pt-5'}`}>
            {/* filter */}
            <div className="row m-0">
              {/* tim kiem */}
              {/* <div className="pl-0 pr-0 pr-md-4 col-xl-3 col-md-4 mb-3">
                {UIHelper.buildFormLabel('Tìm kiếm')}
                <KTFormSearch
                  name="search"
                  placeholder="Nhập để tìm kiếm..."
                  value=""
                  onSubmit={(text) => {}}
                />
              </div> */}
              {/* loc theo trang thai */}
              <div className="pl-0 pr-0 pr-md-4 col-xl-3 col-md-4 mb-3">
                {UIHelper.buildFormLabel('Trạng thái')}
                <KTBSDropdown
                  name="status"
                  toggleElement={
                    <button
                      className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                      type="button"
                    >
                      {_.find(AgencyHelper.Data.reconciliationStatusOptions, {
                        value: filter.status,
                      })?.name ?? 'Tất cả'}
                    </button>
                  }
                  selectedValue={filter.status}
                  dropdownMenuItems={[
                    { name: 'Tất cả', value: '' },
                    ...AgencyHelper.Data.reconciliationStatusOptions,
                  ]}
                  dropdownMenuClassName="overflow-auto w-100"
                  dropdownMenuStyle={{ maxHeight: '30vh' }}
                  onChange={(value) => {
                    setFilter({ ...filter, status: value });
                  }}
                  isDropdownForm={true}
                />
              </div>
              {/* loc theo loai doi soat */}
              {_.isEmpty(initialRole) && (
                <div className="pl-0 pr-0 pr-md-4 col-xl-3 col-md-4 mb-3">
                  {UIHelper.buildFormLabel('Loại đối soát')}
                  <KTBSDropdown
                    name="forRole"
                    toggleElement={
                      <button
                        className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                        type="button"
                      >
                        {_.find(AgencyHelper.Data.reconciliationRoleOptions, {
                          value: filter.forRole,
                        })?.name ?? 'Tất cả'}
                      </button>
                    }
                    selectedValue={filter.forRole}
                    dropdownMenuItems={[
                      { name: 'Tất cả', value: '' },
                      ...AgencyHelper.Data.reconciliationRoleOptions,
                    ]}
                    dropdownMenuClassName="overflow-auto w-100"
                    dropdownMenuStyle={{ maxHeight: '30vh' }}
                    onChange={(value) => {
                      setFilter({ ...filter, forRole: value });
                    }}
                    isDropdownForm={true}
                  />
                </div>
              )}

              {/* loc theo thang doi soat */}
              <div className="pl-0 pr-0 pr-md-4 col-xl-3 col-md-4 mb-3">
                {UIHelper.buildFormLabel('Tháng đối soát')}
                <KTFormInput
                  name="month"
                  type={KTFormInputType.month}
                  onChange={(value) => {
                    setFilter({ ...filter, month: value });
                  }}
                  value={filter.month}
                />
              </div>
            </div>

            {/* table */}
            <div className="mb-3">
              <KTTable
                columns={fullColumns}
                items={reconciliationList}
                selectableRows={false}
                striped={false}
                compactGrid={false}
                onClickedRow={(row) => { }}
                onSelectedRowsChanged={(rows) => { }}
                onDoubleClickedRow={(row) => { }}
                noDataComponent={
                  <EmptyView
                    icon={imgEmptyNoData}
                    title="Không có dữ liệu để hiển thị"
                    text={<span>Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.</span>}
                  />
                }
              />
            </div>
          </div>
        </div>,
        false,
        !showFullUI
      )}
    </div>
  );
}

export default AgencyReconciliationListView;
